import { classNames } from "primereact/utils";

import { useFormFieldContext } from "../form-field.context";
import styles from "../form-field.module.scss";
import type { FormFieldErrorProps } from "../types-form-field";

export function FormFieldErrorMessage({ className, ...rest }: FormFieldErrorProps) {
  const { error, errorId, partTestId, classNames: parts } = useFormFieldContext();

  return error ? (
    <p
      className={classNames(styles.error, parts.error, className)}
      data-testid={partTestId("error")}
      {...rest}
      id={errorId}
      role="alert"
    >
      {error}
    </p>
  ) : null;
}
FormFieldErrorMessage.displayName = "FormField.Error";
